import { IonCard, IonCardContent, IonText, useIonRouter } from '@ionic/react';
import { formatFollowersCount } from '../utils/channelText';

interface ChannelProfileSectionProps {
  channel: {
    id: string;
    name: string;
    followersCount: number;
  };
}

export const ChannelProfileSection: React.FC<ChannelProfileSectionProps> = ({ channel }) => {
  const ionRouter = useIonRouter();

  const followersLabel = formatFollowersCount(channel.followersCount);

  return (
    <IonCard>
      <IonCardContent>
        <div className="flex flex-col gap-2">
          <IonText className="text-base text-gray-900">
            <p className="m-0">{channel.name}</p>
          </IonText>

          <div className="flex items-center gap-4">
            <button
              type="button"
              className="text-sm text-primary font-medium cursor-pointer bg-transparent p-0"
              onClick={() => ionRouter.push(`/app/main/perfil/canal/${channel.id}/seguidores`)}
              data-testid="channel-followers-link"
            >
              {followersLabel}
            </button>
            <span className="text-gray-400">|</span>
            <button
              type="button"
              className="text-sm text-primary font-medium cursor-pointer bg-transparent p-0"
              onClick={() => ionRouter.push(`/app/main/perfil/canal/${channel.id}/editar`)}
              data-testid="channel-edit-link"
            >
              Editar canal
            </button>
          </div>
        </div>
      </IonCardContent>
    </IonCard>
  );
};
